import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import YouTube from 'react-youtube';
import { Link } from '../../routes';
import Img from '../01_atoms/Img';

const PortfolioItem = ({
  imageForGrid,
  whiteIcon,
  siteType,
  video,
  gridDescription,
  title,
  path,
}) => {
  if (typeof imageForGrid !== 'string' || !imageForGrid.length) {
    return null;
  }
  return (
    <Link to={path}>
      <a className="works__hover">
        <LazyLoad height={285} once>
          {typeof video !== 'undefined' && video !== null && video.length
            ? (
              <YouTube
                videoId={video.split('/').pop()}
                opts={{
                  playerVars: {
                    autoplay: 1,
                    mute: 1,
                    controls: 0,
                    showinfo: 0,
                    modestbranding: 1,
                    loop: 1,
                    width: 570,
                    height: 330,
                    playlist: video.split('/').pop(),
                  },
                }}
              />
            )
            : <Img src={imageForGrid} alt={title} />}
        </LazyLoad>
        <div className="works__hover--show d-flex flex-column">
          <div className="ibb">
            { whiteIcon && whiteIcon.length > 0
              ? <Img src={whiteIcon} alt="icon" /> : null
            }
          </div>
          <h4 className="font-weight-medium">{title}</h4>
          <div dangerouslySetInnerHTML={{ __html: gridDescription }} className="flex-grow-1" />
          <div className="d-flex justify-content-between portfolio-item__hover--bottom">
            <div className="link_arrow p-0">
              <span className="text-white">Просмотреть проект</span>
            </div>
            {siteType !== null && <p>{siteType}</p>}
          </div>
        </div>
      </a>
    </Link>
  );
};

PortfolioItem.propTypes = {
  whiteIcon: PropTypes.string,
  siteType: PropTypes.string,
  gridDescription: PropTypes.string,
  video: PropTypes.string,
  imageForGrid: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
};

PortfolioItem.defaultProps = {
  whiteIcon: null,
  siteType: null,
  gridDescription: null,
  video: null,
  imageForGrid: null,
  title: null,
  path: null,
};

export default PortfolioItem;
